import Box from '@mui/material/Box';

export default function BannerImage({ banner }) {
    return (
        <>
            {banner?.image && (
                <Box
                    sx={{
                        maxWidth: '1920px',
                        height: { md: '336px', xs: 'auto' },
                        minHeight: { md: 'auto', xs: '230px', sm: '240px' },
                        marginBottom: { md: '-135px', xs: '-15%' },
                        overflow: 'hidden',
                        backgroundColor: banner.background,
                        textAlign: banner.alignment || 'center',
                        backgroundPositionY: 'top',
                        backgroundPositionX: banner.cover === 'fill' ? 'center' : banner.alignment || 'center',
                        width: banner.cover === 'fill' ? '100%' : 'auto',
                        backgroundImage: `url(${banner.image})`,
                        backgroundSize: banner.cover === 'fill' ? 'cover' : 'contain',
                        backgroundRepeat: 'no-repeat',
                        WebkitBackgroundSize: banner.cover === 'fill' ? 'cover' : 'contain',
                    }}
                />
            )}
        </>
    );
}
